<template>
    <div id="month_year_ddl" v-if="isInitSuccess">
        <div id="month_ddl">
            <InputDropdown
                :addClass="customClass"
                :errorInfo="errorInfoMonth"
                :inputLbl="inputLbl.month"
                :itemList="monthList"
                v-model="monthInput"
                @input="onMonthChange($event)" />
        </div>
        <div id="year_ddl">
            <InputDropdown
                :addClass="customClass"
                :errorInfo="errorInfoYear"
                :inputLbl="inputLbl.year"
                :itemList="yearList"
                v-model="yearInput"
                @input="onYearChange($event)" />
        </div>
    </div>
</template>
<script>
//component
import InputDropdown from '@/components/Input/Dropdown.vue';
export default {
    name: 'MonthYearDDL',
    components: {
        InputDropdown
    },
    props: {
        customClass: String,
        lbl: Object,
        inputLbl: Object,
        localeCode: Number,
        value: Date,
    },
    data: function () {
        return {
            id: '',
            label: '',
            content: this.value,
            isInitSuccess: false,


            dateValue: {
                month: '',
                year: ''
            },

            errorInfoMonth: { isValid: false, msg: '' },
            errorInfoYear: { isValid: false, msg: '' },

            monthList: [],
            yearList: [],

            dayInput: '',
            monthInput: '',
            yearInput: ''
        };
    },
    created: function () {
        this.setMonthList();
        this.setYearList();

        this.setDateInitial();
    },
    mounted: function () {
        this.isInitSuccess = true;
    },
    methods: {
        //#region event
        onMonthChange: function (val) {
            this.dateValue.month = val;
            this.setDateOnChange();
        },
        onYearChange: function (val) {
            this.dateValue.year = val;
            this.setDateOnChange();
        },
        //#endregion
        //#region setter
        setDateInitial: function () {
            if (this.value) {
                let m = this.value.getMonth();
                let y = this.value.getFullYear();

                this.monthInput = m + 1 + '';
                this.dateValue.month = m + 1 + '';
                this.yearInput = y + '';
                this.dateValue.year = y + '';
            }
        },
        setDateOnChange: function () {
            let month = this.dateValue.month.padStart(2, '0');
            let year = this.dateValue.year;

            let output = {
                date: `${year}-${month}-01T00:00:00`,
            };

            this.$emit('onDateChange', output);
        },
        setMonthList: function () {
            let months = this.lbl.date.month_full;
            let list = [];
            for (let i in months) {
                let index = (parseInt(i, 10) + 1) + '';
                list.push({
                    value: index,
                    text: months[i]
                })
            }

            this.monthList = list;
        },
        setYearList: function () {
            let yearValue = parseInt(new Date().getFullYear(), 10);
            let yearText = this.localeCode == 1054 ? yearValue + 543 : yearValue;
            let list = []

            for (let i = 0; i < 2; i++) {
                list.push({
                    value: yearValue - i + '',
                    text: yearText - i + ''
                });
            }

            this.yearList = list;
        }
        //#endregion
    }
}
</script>
<style lang="scss" scoped>
@import '@/style/base/base.scss';
@import '@/style/base/baseDisplay';
#month_year_ddl {
    @extend %display-flex;
    max-width: 500px;
    margin: {
        left: auto;
        right: auto;
    }
    padding: {
        left: $lr-screen-padding;
        right: $lr-screen-padding;
        bottom: 25px;
    };

    #month_ddl {
        width: 60%;
        flex: 0 0 60%;
        padding-right: 10px;
    }

    #year_ddl {
        width: 40%;
        flex: 0 0 40%;
        padding-left: 10px;
    }
}
</style>
